import { useTranslation } from "react-i18next";
import "./DataNotAvailable.scss";
interface DataNotAvailableProps {
  text?: string;
}
const DataNotAvailable = ({
  text = "GENERAL.DATA_NOT_FOUND",
}: DataNotAvailableProps) => {
  const { t } = useTranslation();
  return (
    <div className="dataNotAvailable mt-4 p-5">
      <h2>{t(text)}</h2>
    </div>
  );
};

export default DataNotAvailable;
